import qs from 'qs';

const paramCache = {};
const qsConfig = { skipNulls: true, arrayFormat: 'repeat' };

const getSearchString = function (str) {
  if (!str) {
    return '';
  }
  return str.substr(str.indexOf('?') > -1 ? str.indexOf('?') + 1 : 0);
};

const getUrlParam = function (name, searchString) {
  let searchStr = searchString;
  if (!searchStr) {
    searchStr = window.location.search;
  }

  if (!paramCache[searchStr]) {
    searchStr = getSearchString(searchStr);
    paramCache[searchStr] = qs.parse(searchStr, qsConfig);
  }
  if (name) {
    return paramCache[searchStr][name];
  }
  return paramCache[searchStr];
};

export {paramCache, getUrlParam};
